<template>
  <div class="page-selector container d-flex flex-wra mb-3">
    <div>
      <div class="text-primary text-center">
        {{$t('pagination.results.results')}}
        <span v-html="$fn(currentOffset + 1)"></span>
        {{$t('pagination.results.to')}}
        <span v-html="$fn(currentOffset + resultsInCurrentPage)"></span>
        {{$t('pagination.results.of')}}
        <span :title="$t('result.matching_expressions.pagination.types')"
              v-html="$fn(numberOfElements)"></span>
        <span :title="$t('result.matching_expressions.pagination.tokens')"
               v-html="`(${$fn(totalElements)})`"></span>
      </div>
      <ncs-pagination-links/>
    </div>
    <ncs-go-to-page class="ml-auto align-self-end"/>
    <div class="d-flex ml-auto align-self-end mt-3">
      <ncs-download-button/>
      <ncs-label id="download-instructions" class="align-self-center ml-3"/>
    </div>
  </div>
</template>
<script>
  import NcsMatchingExpressionsPageSelector from 'ncs/js/components/results/matching_expressions/NcsMatchingExpressionsPageSelector'

  export default {
    extends: NcsMatchingExpressionsPageSelector,
  }
</script>
